// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kZc4","label":"styles_label__2qohQ"};